import {useEffect, useState} from "react";
import cn from "classnames";

import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";
import {SliderGallery} from "@pg-design/slider-gallery-module";
import {Text} from "@pg-design/text-module";

import {dayNamesArray} from "../constants/day_names_array";
import type {ICalendarDate} from "../types/ICalendarDate";
import {ICalendarSliderProps} from "../types/ICalendarSliderProps";
import {getDaysArray} from "../utils/get_days_array";
import {CalendarCard} from "./CalendarCard";
import {HourSelect} from "./HourSelect";

import * as styles from "./CalendarSlider.module.css";

export const CalendarSlider = (props: ICalendarSliderProps) => {
    const [selectedDay, setSelectedDay] = useState<ICalendarDate | undefined>(undefined);

    const daysArray = getDaysArray(30);

    const availableDaysIds =
        props.hourOptions && props.hourOptions.length > 0
            ? props.hourOptions.map((day) => dayNamesArray.indexOf(day.dayName))
            : Array.from(dayNamesArray.keys(), (index) => index).filter((dayId) => ![0, 6].includes(dayId));
    const activeDaysArray = daysArray.reduce((acc: ICalendarDate[], dayData: ICalendarDate) => {
        if (availableDaysIds?.includes(dayData.dayId) || !availableDaysIds) {
            return acc.concat(dayData);
        }
        return acc;
    }, []);

    const onDaySelect = (day: ICalendarDate) => {
        setSelectedDay(day);
    };

    useEffect(() => {
        if (selectedDay) {
            props.onChange?.(selectedDay);
        }
    }, [selectedDay]);

    return (
        <div className={props.className}>
            <Text variant="body_copy_2" className={styles.sliderHeader}>
                {props.headline}
            </Text>
            <div className={cn(styles.sliderHolder, props.sliderClassName)}>
                <SliderGallery
                    slides={activeDaysArray.map((dayData: ICalendarDate, index: number) => {
                        const isSelectedDay = checkIfDaysAreSimilar(dayData, selectedDay);

                        if (availableDaysIds?.includes(dayData.dayId)) {
                            return <CalendarCard dayData={dayData} key={index} onClick={onDaySelect} isSelected={isSelectedDay} />;
                        }
                        return null;
                    })}
                    arrows={{
                        left: (
                            <div className={cn(styles.arrow, styles.arrowLeft)}>
                                <ChevronLeftIcon wrapperColor="#fff" wrapperSize="2.4" size="1.5" />
                            </div>
                        ),
                        right: (
                            <div className={cn(styles.arrow, styles.arrowRight)}>
                                <ChevronRightIcon wrapperColor="#fff" wrapperSize="2.4" size="1.5" />
                            </div>
                        )
                    }}
                    clonedSlidesCount={0}
                    slidesToShow={3}
                    sliderWrapperClass={styles.sliderWrapper}
                />
            </div>
            <HourSelect
                hourOptions={props.hourOptions}
                selectedDay={selectedDay}
                hourSelectPlaceholder={props.hourSelectPlaceholder}
                onHourChange={(hour: string) => {
                    if (selectedDay) {
                        setSelectedDay({...selectedDay, hour});
                    }
                }}
            />
        </div>
    );
};

const checkIfDaysAreSimilar = (dayData: ICalendarDate, selectedDay?: ICalendarDate) => {
    if (!dayData || !selectedDay) {
        return false;
    }

    const sameDay = dayData.day === selectedDay.day;
    const sameMonth = dayData.month === selectedDay.month;
    const sameYear = dayData.year === selectedDay.year;

    return sameDay && sameMonth && sameYear;
};
import {useEffect, useState} from "react";
import cn from "classnames";

import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";
import {SliderGallery} from "@pg-design/slider-gallery-module";
import {Text} from "@pg-design/text-module";

import {dayNamesArray} from "../constants/day_names_array";
import type {ICalendarDate} from "../types/ICalendarDate";
import {ICalendarSliderProps} from "../types/ICalendarSliderProps";
import {getDaysArray} from "../utils/get_days_array";
import {CalendarCard} from "./CalendarCard";
import {HourSelect} from "./HourSelect";

import * as styles from "./CalendarSlider.module.css";

export const CalendarSlider = (props: ICalendarSliderProps) => {
    const [selectedDay, setSelectedDay] = useState<ICalendarDate | undefined>(undefined);

    const daysArray = getDaysArray(30);

    const availableDaysIds =
        props.hourOptions && props.hourOptions.length > 0
            ? props.hourOptions.map((day) => dayNamesArray.indexOf(day.dayName))
            : Array.from(dayNamesArray.keys(), (index) => index).filter((dayId) => ![0, 6].includes(dayId));
    const activeDaysArray = daysArray.reduce((acc: ICalendarDate[], dayData: ICalendarDate) => {
        if (availableDaysIds?.includes(dayData.dayId) || !availableDaysIds) {
            return acc.concat(dayData);
        }
        return acc;
    }, []);

    const onDaySelect = (day: ICalendarDate) => {
        setSelectedDay(day);
    };

    useEffect(() => {
        if (selectedDay) {
            props.onChange?.(selectedDay);
        }
    }, [selectedDay]);

    return (
        <div className={props.className}>
            <Text variant="body_copy_2" className={styles.sliderHeader}>
                {props.headline}
            </Text>
            <div className={cn(styles.sliderHolder, props.sliderClassName)}>
                <SliderGallery
                    slides={activeDaysArray.map((dayData: ICalendarDate, index: number) => {
                        const isSelectedDay = checkIfDaysAreSimilar(dayData, selectedDay);

                        if (availableDaysIds?.includes(dayData.dayId)) {
                            return <CalendarCard dayData={dayData} key={index} onClick={onDaySelect} isSelected={isSelectedDay} />;
                        }
                        return null;
                    })}
                    arrows={{
                        left: (
                            <div className={cn(styles.arrow, styles.arrowLeft)}>
                                <ChevronLeftIcon wrapperColor="#fff" wrapperSize="2.4" size="1.5" />
                            </div>
                        ),
                        right: (
                            <div className={cn(styles.arrow, styles.arrowRight)}>
                                <ChevronRightIcon wrapperColor="#fff" wrapperSize="2.4" size="1.5" />
                            </div>
                        )
                    }}
                    clonedSlidesCount={0}
                    slidesToShow={3}
                    sliderWrapperClass={styles.sliderWrapper}
                />
            </div>
            <HourSelect
                hourOptions={props.hourOptions}
                selectedDay={selectedDay}
                hourSelectPlaceholder={props.hourSelectPlaceholder}
                onHourChange={(hour: string) => {
                    if (selectedDay) {
                        setSelectedDay({...selectedDay, hour});
                    }
                }}
            />
        </div>
    );
};

const checkIfDaysAreSimilar = (dayData: ICalendarDate, selectedDay?: ICalendarDate) => {
    if (!dayData || !selectedDay) {
        return false;
    }

    const sameDay = dayData.day === selectedDay.day;
    const sameMonth = dayData.month === selectedDay.month;
    const sameYear = dayData.year === selectedDay.year;

    return sameDay && sameMonth && sameYear;
};
